//@ts-check

module.exports = {
  no_pargma_statement_error:
    "Cannot compile your code. It is missing the pragma statement.",
  functionality_description: [
    "Verify that the smart contract follows the ERC-20 standard syntax and best practices of implementation. Following the standard and applying best practices allows accurate predictions of interaction with tokens among developers, users, wallet applications and other related services such as exchanges and blockchain explorers.",
  ],
  overview_description: [
    "General information on the smart contract and basic token features.",
  ],
  security_description: [
    "Identify vulnerabilities and other information security related practices in the smart contract. This involves analysis of the static source-code and dynamic execution of the contract in a sandboxed Ethereum Virtual Machine (EVM).",
  ],
  efficiency_description: [
    "Evaluate the amount of gas spent by different methods in the smart contract and look for improvements that could reduce gas costs. The less gas consumed, the cheaper the transaction.",
  ],
  quality_description: [
    "Evaluate how well the smart contract source code is written, structured and documented. Low quality code carries a higher risk of unidentified bugs and errors.",
  ],
  extractCodeFromMainnetButton: "Extract source code using a Mainnet address",
  uploadSolidityFile: "Upload Solidity file",
  select_file: "Select file",
  source_code: "Source code",
  you_can_also_directly: "You can directly ",
  copy_and_paste_and_edit: "edit ",
  my_texts_description: ["My texts description..."],
  your_code_below: "your code below ",
  hide_code: "HIDE CODE",
  show_code: "SHOW_CODE",
  submit: "SUBMIT",
  scan: "Scan",
  token_and_smart_contract_testing_intro_start:
    "Assess the validity of an ERC-20 based Smart Contract by testing the Functionality implementation, Security risks mitigation, Efficiency of use and Quality of coding. Simply use one of the four input methods, select the Solidity version, click Scan and review the results.",
  token_and_smart_contract_testing_intro_start_multifile:
    "Assess the validity of an ERC-20 based Smart Contract by testing the Functionality implementation, Security risks mitigation, Efficiency of use and Quality of coding. Simply use one of the three input methods, select the main contract and Solidity version, click Scan and review the results.",
  select_input_method: "Select Input Method:",
  compilation_failed: "Compilation of Solidity Code Failed",
  submitLoadingText: "Analyzing the smart contract...",
  loadingSolidityCode: "Extracting Solidity code from the Mainnet",
  extracting: "Extracting Solidity Code into the editor...",
  extract_code: "Extract Code",
  solidity_version: "Solidity version",
  cannotRetrieveCode: "The code could not be retrieved!",
  CHOOSE_ERC20_TOKEN: "Choose an ERC-20 token",
  show_example_pass_test: "Example of Solidity code that will pass this test",
  show_example_fail_test: "Example of Solidity code that will fail this test",
  not_available_for_this_smart_contract:
    "This test is not available for this smart contract",

  erc20_token: "ERC-20 Token",
  enter_edit_source_code: "Enter/Edit Source Code",
  select_from_list_of_tokens: "Select from List of Tokens",
  extract_from_mainnet_address: "Extract from Mainnet Address",
  upload_solidity_file: "Upload Solidity File",
  warning: "Warning",
  passed: "Passed",
  info: "Informational",
  informational: "Informational",
  failed: "Failed",
  detailed_test_results: "Detailed test results",
  source: "Source",
  date_list_created:
    "(The list of tokens was compiled on Sep. 10, 2019, based on market cap)",
  token_and_contract_testing: "Smart Contract and Token Review",
  home: "Home",
  code_extracted: "Code extracted",
  recommendation_heading: "Recommendation:",
  solidity_error_no: "No",
  solidity_error_version: "Solidity version",
  solidity_error_rest:
    "has been found in source code. Please select it manually.",
  collapse_all: "Collapse all",
  file_uploaded: "File uploaded",
  deploy: "Deploy",
  was_successfully_uploaded: "was successfully uploaded.",
  constructor_variable:
    "Defined during deployment. Variable was not defined in the source code.",
  test_abi_function_title:
    'The "{name}" function definition follows {standard_name}',
  test_abi_function_description: `Check if the "{name}" function's input and output variables follow {standard_name} requirements. This test validates that there is an exact match in the number of arguments and the corresponding types.
    
    {purpose}

    Services like wallet applications and blockchain explorers that follow {standard_name} will be able to interact with the smart contract by calling this function and displaying data associated with it.

    Recommendation: Consider updating the function's signature to follow the standard and adding the required logic.
    `,
  test_abi_erc20_event_title:
    'The "{name}" event definition follows {standard_name}',
  test_abi_erc20_event_description: `Check if the "{name}" event signature matches the format required by {standard_name}. This test validates that there is an exact match in the number of arguments, their type, the use of the 'indexed' keyword and the event name.

    {purpose}
    
    Services like wallet applications and blockchain explorers that follow the standard will be able to interact with the smart contract, and to display relevant data.
    
    Recommendation: Consider updating the event's signature to follow {standard_name} and review that the input variables are used correctly every time the smart contact emits the event.`,
  NEVER_ENDING_LOOPS_FAILED:
    "The function can fail since it dependents on the number {variable}",
  functionalityLimitations:
    "Although there are some methods that the test-runner is using to create the transactions, it is still possible that hard-coded smart contract limitations are preventing this test from being executed or changing its behavior during run time. E.g the existence of a white-list, time-locked tokens, an open crowdsale or tokens that are in pause or freeze mode.",
  eventDescription:
    "Events are used in Ethereum as a way for smart contracts to notify client apps and services about important behavior occurring on chain.",
  forTesting:
    "For testing, the test runner deploys the smart contract to a sandboxed environment and then creates transactions that simulate this behavior.",
  recommendationSwitchToOpenSource:
    'Recommendation: Check the logic of the "{name}" function. Consider migrating to an audited open-source library that contains an implementation of the required behavior.',
  randomRiskAndRecommendation: `Smart contract developers often use this variable for several functionalities, such as generating a random number. However, if a miner were to gain control of this variable, it could lead to an unexpected result. For example, although a smart contract may be expected to deliver funds to a random winner, a miner with control over this variable could make the smart contract deliver the funds to an address that they own.

Recommendation:
Consider migrating to a different method of generating random numbers. For example, the code could require that each participant contribute to the seed that creates the random number.

Links:
https://ethereum.stackexchange.com/questions/191/how-can-i-securely-generate-a-random-number-in-my-smart-contract
https://github.com/randao/randao/blob/master/README.md
`,
  randomRiskAndRecommendation_risk: `Smart contract developers often use this variable for several functionalities, such as generating a random number. However, if a miner were to gain control of this variable, it could lead to an unexpected result. For example, although a smart contract may be expected to deliver funds to a random winner, a miner with control over this variable could make the smart contract deliver the funds to an address that they own.`,
  randomRiskAndRecommendation_recommendation: `Consider migrating to a different method of generating random numbers. For example, the code could require that each participant contribute to the seed that creates the random number.
`,
  forAnalyzingSolidity:
    "In order to run the tests, the test-runner compiles the smart contract code and generates the abstract interface of the token. It then iterates over this interface and checks for matching patterns.",
  whenTestNotAvailable:
    "When this test is not available, it indicates that the pre-configuration required steps are not met, and the test-runner was not able to execute the test on the smart contract.",
  riskApprove:
    "If this test fails, there is more of a risk that the user will not be able to make a transfer, or will be able to transfer the wrong amount.",
  senderExplanation:
    "Every Ethereum transaction has the 'sender' property, which means who initiates the transaction. Smart contracts can access this property by using the `msg.sender` or `tx.origin` Solidity variables.",
  show_in_code_editor: "Show in code editor",
  blockchain_ey_com: "Blockchain.ey.com",
  n_a: "N/A",
  file_explorer: "File explorer",
  upload: "Upload",
  folder: "Folder",
  file: "File",
  smart_contract_to_deploy: "Smart Contract to deploy",
  upload_file: "Upload File",
  upload_folder: "Upload Folder",
  new_file: "New File",
  new_folder: "New Folder",
  delete: "Delete",
  rename: "Rename",
  create_file_in_root_dir: "Create file in root",
  create_folder_in_root_dir: "Create folder in root",
  scanning: "Scanning",
  cancel: "Cancel",
  clearAll: "Clear All",
  sorry_no_results_match_your_selection: "Sorry, no results match your selection."
}
